import styled from "vue-styled-components";

export const Content = styled.div`
    img {
        margin-bottom: 2rem;
        width: 100%;
        max-height: 300px;
        object-fit: cover;
    }
`;
